export default __webpack_public_path__ + "static/media/Uniquelogo.78dbf916.png";